import React, { useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { getLatestDateFromData } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";

const JointVenture = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: jointVentureData = [], isLoading: jointVentureDataIsLoading } =
    useGetProtectedApiDataQuery({ url: "joint_venture", lang: languageType });

  useTableResponsive(jointVentureData);

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(jointVentureData);
  }, [jointVentureData]);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  if (jointVentureDataIsLoading) {
    return <Loader />;
  }
  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={getText("Power Generation", "विद्युत उत्पादन")}
        titleLink="/power-generation"
        levelTwo={true}
        titleTwo={innerBannerTitle}
        levelThree={false}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                {/* <div className="d-flex justify-content-between title-sec">
                  <h2 className="">
                    {getText(
                      "Joint Venture Plants",
                      "संयुक्त उद्यम परियोजनाएं"
                    )}
                  </h2>
                </div> */}
                <div className="title-sec">
                  <h2 className="title4">
                    {getText(
                      "Plants/ Joint Venture Plants",
                      "संयंत्र/संयुक्त उद्यम संयंत्र",
                    )}
                  </h2>
                </div>
                <p>
                  {getText(
                    "Plants of NEEPCO in various stages of development in joint venture basis are as follows:",
                    "संयुक्त उद्यम के आधार पर विकास के विभिन्न चरणों में नीपको के संयंत्र इस प्रकार हैं:",
                  )}
                </p>
                <h2 className="title4">
                  {getText("Future Projects", "भविष्य की परियोजनाएं")}
                </h2>
                <p>{getText("HYDRO", "जल")}</p>
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-2">
                <div className="table-responsive mb-2">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th className="no-wrap-td">
                          {getText("S.No.", "क्र. सं.")}
                        </th>
                        <th>
                          {getText("Name of the Project", "परियोजना का नाम")}
                        </th>
                        <th>{getText("State", "राज्य")}</th>
                        {/* <th>{getText("Status", "स्थिति")}</th> */}
                        <th>{getText("Status", "स्थिति")}</th>
                        {/* <th>
                          {getText(
                            "Commissioning schedule (tent. from investment approval)",
                            "कमीशनिंग शेड्यूल"
                          )}
                        </th> */}
                        {/* <th>{getText("Details", "विवरण")}</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {jointVentureData.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {item.field_sl_no}
                          </td>
                          <td
                            data-key={getText(
                              "Project Name",
                              "परियोजना का नाम",
                            )}
                          >
                            {item.title}
                          </td>
                          <td data-key={getText("State", "राज्य")}>
                            {item.field_state}
                          </td>
                          <td data-key={getText("Status", "स्थिति")}>
                            {item.field_status_power}
                          </td>
                          {/* <td></td> */}
                          {/* <td data-key={getText("Details", "विवरण")}>
                            <div
                              dangerouslySetInnerHTML={{ __html: item.body }}
                            ></div>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p>
                  {getText(
                    "Besides, Hydro Projects under Construction and Hydro Projects in Pipeline in Arunachal Pradesh shall also be developed with the State Govt. in joint venture with the State Govt.",
                    "अरुणाचल प्रदेश में निर्माणाधीन हाइड्रो परियोजनाओं और पाइपलाइन में हाइड्रो परियोजनाओं को भी राज्य सरकार के साथ संयुक्त उद्यम में विकसित किया जाएगा।",
                  )}
                </p>
              </div>

              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JointVenture;
